<template>
  <el-dialog
    title="身份验证"
    width="600px"
    :show-close="false"
    custom-class="system-dialog"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :before-close="close"
  >
    <div class="form-box">
      <div class="form-item">
        <div class="item-label">手机号：</div>
        <div class="item-value">
          <el-input
            disabled
            placeholder="请输入..."
            v-model="phone"
            style="width: 280px"
          ></el-input>
        </div>
      </div>
      <div class="form-item">
        <div class="item-label">验证码：</div>
        <div class="item-value">
          <el-input
            placeholder="请输入"
            v-model="code"
            style="width: 170px; margin-right: 12px"
          ></el-input>
          <el-button
            type="primary"
            :disabled="codeDisabled"
            @click="getCodeInit"
            >{{ codeMsg }}</el-button
          >
        </div>
      </div>
    </div>

    <div class="save-btn" style="margin-top: 30px;">
      <el-button class="keepBtn" type="primary" @click="submit()">确定</el-button>
      <el-button class="backBtn" @click="close">取消</el-button>
    </div>
  </el-dialog>
</template>

<!-- 
  该组件为导出前验证弹窗，
  当请求的用户信息中 isOpenDownloadRemind == 0 时，
  代表着全局导出身份验证按钮是开启状态，
  需要进行手机验证码验证才能导出
  -->
<script>
import {
  getmoble,
  getSellerCheckCode,
} from "@/api/paradiseAndTaskCommonController.js";

export default {
  props:{
    visible:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      phone: "",
      code: "",
      codeDisabled: false,
      codeMsg: "获取验证码",
      countdown: 60,
      timer: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const { data: res } = await getmoble();
      this.phone = res.mobile;
    },
    submit() {
      if(/^\s*$/.test(this.code)) {
        this.$message.error("请输入验证码");
        return
      }
      this.$emit("submit", { phone: this.phone, code: this.code });
      this.$emit("close");
      this.code = "";
    },
    close() {
      this.$emit("close");
      this.code = "";
    },
    /** 获取验证码 */
    getCodeInit() {
      if (!this.timer) {
        getSellerCheckCode().then((res) => {
          if (res.code == 1) {
            this.codeDisabled = true;
            this.timer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--;
                if (this.countdown !== 0) {
                  this.codeMsg = "重新发送(" + this.countdown + ")";
                } else {
                  clearInterval(this.timer);
                  this.codeMsg = "获取验证码";
                  this.countdown = 60;
                  this.timer = null;
                  this.codeDisabled = false;
                }
              }
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-box {
  padding-top: 16px;
  .form-item {
    font-size: 14px;
    color: #333;
    margin-bottom: 12px;
    .item-label {
      display: inline-block;
      width: 76px;
      text-align: right;
    }
    .item-label2 {
      display: inline-block;
      width: 100px;
      text-align: right;
    }
    .item-value {
      display: inline-block;
    }
  }
}
.save-btn {
  text-align: center;
}
</style>
